<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <user-list
          @form="dialog = true"
          @clear="$refs.form && $refs.form.clear()"
        />
        <user-form
          v-if="dialog"
          ref="form"
          :dialog="dialog"
          @close="dialog = false"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UserForm from './FormManager'
import UserList from './List'
export default {
  name: 'Users',
  components: {
    UserList,
    UserForm,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.resetState()
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchRoles: 'roles/fetchSelectList',
      fetchUsers: 'users/fetchList',
      resetState: 'users/resetState',
      setStatus: 'events/setStatus',
    }),
    async initData() {
      // this.resetPagitations()
      await Promise.all([this.fetchUsers(), this.fetchRoles({ limit: 0 })])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    },
  },
}
</script>
